module.exports = {
  SIDEBAR_WIDTH: 250,
  NAVBAR_HEIGHT: 64,
  MOBILE_NAVBAR_HEIGHT: 76,
};
